import styled, { keyframes } from 'styled-components'

const rotation = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(359deg); }
`

export const Svg = styled.svg`
  width: ${({ size }) => {
        if (size === 'xs') return '1.5rem'
        if (size === 's') return '2rem'
        if (size === 'm') return '3.5rem'
        if (size === 'l') return '6rem'
    }};
  height: ${({ size }) => {
        if (size === 'xs') return '1.5rem'
        if (size === 's') return '2rem'
        if (size === 'm') return '3.5rem'
        if (size === 'l') return '6rem'
    }};
  animation: ${rotation} 5s infinite linear;

  circle {
    fill: none;
    stroke: ${({ theme }) => theme.color.blur};
    stroke-width: 2px;
  }

  circle:nth-child(2) {
    stroke: ${({ theme }) => theme.color.active};
    stroke-dasharray: 310;
    /*  reduce stroke-dashoffset to start the circle progress  */
    stroke-dashoffset: ${props => 240};
  }
`


// WEBPACK FOOTER //
// ./src/Loader/styles.js